export const percentageChange = (a: number, b: number) => {
  let percent;

  if (b !== 0) {
    if (a !== 0) {
      percent = ((b - a) / a) * 100;
    } else {
      percent = b * 100;
    }
  } else {
    percent = 100;
  }

  return Math.abs(percent).toFixed(2);
};

export const getScreenshotFilename = (key: string) => `booking-${key}-summary`;
